import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {BillData, CarrierBillDto, TemplateSubmisionRequest} from "../../../shipper";
import {
	NgbNav,
	NgbNavContent,
	NgbNavItem,
	NgbNavLinkBase,
	NgbNavLinkButton, NgbNavOutlet
} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {BillTypeSelect} from "./isf.bill.type";
import {IsfContainersPasteInForm} from "./isf.containers.pastein.form";
import {TemplateService} from "../../template.service";
import {IsfBillsContainers} from "./isf.bills.containers";

@Component({
	selector: 'isf-bills-list',
	standalone: true,
	imports: [
		NgbNav,
		FormsModule,
		CommonModule,
		NgbNavContent,
		NgbNavItem,
		NgbNavLinkBase,
		NgbNavLinkButton,
		NgbNavOutlet,
		BillTypeSelect,
		IsfContainersPasteInForm,
		IsfBillsContainers
	],
	template: `

        <div>
            <div class="btn-group btn-group-sm pull-right">
				<button class="btn btn-sm btn-secondary" (click)="clear()">
					<i class="fa fa-recycle me-2"></i>Clear
				</button>
                <button class="btn btn-sm btn-secondary" (click)="addRow()">
					<i class="fa fa-plus-circle me-2"></i>Add
				</button>
			</div>
			
			<ul ngbNav #nav="ngbNav" class="nav-pills" [destroyOnHide]="false" [(activeId)]="activeTab">
				
                <li [ngbNavItem]="1">
                    <button ngbNavLink class="btn-sm">
						<span>House</span>
						<span class="badge bg-white text-black ms-1">{{houseBills.length}}</span>
					</button>
                    <ng-template ngbNavContent >
                        <div class="mt-4">
							
							<div *ngIf="showContainerForm">
								<isf-containers-pastein (onSubmit)="setContainers($event)" (onClear)="closeContainerForm()" [bill]="selectedBill"></isf-containers-pastein>
							</div>
							
							
							<table class="table table-sm table-striped table-bordered table-responsive" *ngIf="showList">
								<thead>
									<tr class="bg-warning">
										<th>Type</th>
                                        <th>Bill No.</th>
                                        <th>Master</th>
										<th>Containers</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let b of houseBills">
										<td class="bill-type"><bill-type [(data)]="b.type" [selected]="b.type" (dataChange)="billTypeCHange($event,b)"></bill-type></td>
										<td>
                                            <input type="text" class="form-control" [(ngModel)]="b.billNumber" />
											<!--<span class="bill-no">{{b.billNumber}}</span> -->
										</td>
                                        <td>
                                            <select class="form-control form-control-sm bill-no" [disabled]="masterBills.length == 0" [(ngModel)]="b.masterBill" (ngModelChange)="masterBill($event)">
                                                <option [value]="null"></option>
												<option *ngFor="let mb of masterBills" [ngValue]="mb" [selected]="b.billNumber == mb.billNumber">{{mb.billNumber}}</option>
                                            </select>
                                        </td>
										
										<td>
											<table class="table table-sm m-0">
												<tbody>
													<tr>
														<td><button class="btn btn-sm btn-secondary" (click)="containerForm(b)">Add</button></td>
														<td>
															<isf-bill-containers [bill]="b"></isf-bill-containers>
														</td>
													</tr>
												</tbody>
												
											</table>
										</td>
										
									</tr>
								</tbody>
								
							</table>
							
                        </div>
                    </ng-template>
                </li>
				
                <li [ngbNavItem]="2">
                    <button ngbNavLink>
						<span>Master</span>
                        <span class="badge bg-white text-black ms-1">{{masterBills.length}}</span>
					</button>
                    <ng-template ngbNavContent >
                        <div class="mt-4">

                            <div *ngIf="showContainerForm">
                                <isf-containers-pastein (onSubmit)="setContainers($event)" (onClear)="closeContainerForm()" [bill]="selectedBill"></isf-containers-pastein>
                            </div>
							
                            <table class="table table-sm table-striped table-bordered table-responsive" *ngIf="showList">
                                <thead>
                                <tr class="bg-warning">
                                    <th>Type</th>
                                    <th>Bill No.</th>
                                    <th>Containers</th>
                                </tr>
                                </thead>
								<tbody>
									<tr *ngFor="let b of masterBills">
										<td class="bill-type"><bill-type [(data)]="b.type" [selected]="b.type" (dataChange)="billTypeCHange($event,b)"></bill-type></td>
                                        <td>
											<input type="text" class="form-control" [(ngModel)]="b.billNumber" />
											<!--<span class="bill-no">{{b.billNumber}}</span>-->
										</td>
                                        <td>
                                            <table class="table table-sm m-0">
                                                <tbody>
													<tr>
														<td><button class="btn btn-sm btn-secondary" (click)="containerForm(b)">Add</button></td>
														<td>
															<isf-bill-containers [bill]="b"></isf-bill-containers>
														</td>
													</tr>
                                                </tbody>

                                            </table>
                                        </td>
									</tr>
								</tbody>
                            
                            </table>
                        </div>
                    </ng-template>
                </li>
			</ul>

            <div [ngbNavOutlet]="nav"></div>
			
        </div>
	`,
	styles:[`
		.bill-type{
			width: 15%;
		}
		.bill-no{
			font-size: 20px;
		}
        .nav>li>button {
            padding-top: 5px;
            padding-bottom: 5px;
        }
	`]
})
export class IsfBillsListForm implements OnInit{
	
	@Input()
	carrierBills:Array<CarrierBillDto> = [];
	
	@Input()
	isf!:TemplateSubmisionRequest;
	
	@Output()
	isfChange:EventEmitter<TemplateSubmisionRequest> = new EventEmitter();
	
	@Output()
	onClear:EventEmitter<void> = new EventEmitter();
	
	@ViewChild("nav",{static:true})
	nav!:NgbNav;
	
	masterBills:Array<BillData> = []
	houseBills:Array<BillData> = [];
	
	showContainerForm:boolean = false;
	showList:boolean = true;
	
	selectedBill!:BillData;
	
	activeTab:number = 1;
	
	constructor(private service:TemplateService) {}
	
	
	ngOnInit(): void {
		
		this.masterBills = this.carrierBills
			.filter(b => b.valid == true)
			.map(b => <BillData>{billNumber:b.bill, type:"OB"});
		
		this.houseBills = this.carrierBills
			.filter(b => b.valid == false)
			.map(b => <BillData>{billNumber:b.bill, type:"BM"});
		
		
		if(this.houseBills.length == 1 && this.masterBills.length == 1){
			this.houseBills[0].masterBill = this.masterBills[0];
		}
		
		this.isf.bills = [...this.houseBills,...this.masterBills];
		
		this.tabActive();
    }
	
	
	/**
	 *
	 */
	tabActive(){
		
		if(this.houseBills.length == 0 && this.masterBills.length > 0){
			this.activeTab = 2;
			return;
		}
		
		this.activeTab = 1;
	}
	
	
	/**
	 *
	 * @param b
	 */
	masterBill(b:any){
		
		this.isf.bills = [...this.houseBills,...this.masterBills];
		
		this.tabActive();
	}
	
	
	/**
	 *
	 * @param type
	 * @param bill
	 */
	billTypeCHange(type:any, bill:BillData){
		
		if(type == "BM"){
			// @ts-ignore
			bill.masterBill = null;
			this.houseBills.push(bill);
			this.masterBills = this.masterBills.filter(b => b.billNumber !== bill.billNumber);
		}
		
		if(type == "OB"){
			this.masterBills.push(bill);
			this.houseBills = this.houseBills.filter(b => b.billNumber !== bill.billNumber);
		}
		
		this.isf.bills = [...this.houseBills,...this.masterBills];
		
		if(this.houseBills.length == 1 && this.masterBills.length == 1){
			this.houseBills[0].masterBill = this.masterBills[0];
		}
		
	}
	
	
	/**
	 *
	 * @param bill
	 */
	containerForm(bill:BillData){
		this.selectedBill = bill;
		this.showContainerForm = true;
		this.showList = false;
	}
	
	
	/**
	 *
	 */
	closeContainerForm(){
		this.showList = true;
		this.showContainerForm = false;
	}
	
	
	/**
	 *
	 * @param containers
	 */
	setContainers(containers:Array<string>){
	
		let containerNumers = containers
			.filter(c => c != "")
			.map((c) => c.trim().toUpperCase().replace(/\W/g, ''));
		
		this.service.getOrCreateContainers(Array.from(new Set(containerNumers))).subscribe((data) => {
			
			this.selectedBill.containers = data.valid;
			this.showList = true;
			this.showContainerForm = false;
		});
	}
	
	
	/**
	 *
	 */
	clear(){
		
		if(confirm("Are you sure you wan't to reset bills?")){
			this.houseBills = [];
			this.masterBills = []
			this.isf.bills = [];
			
			this.onClear.emit();
		}
	}
	
	
	/**
	 *
	 */
	addRow(){
	
		if(this.activeTab == 1)
			{ this.houseBills.push(<BillData>{type:"BM", billNumber:""}); }
		else
			{ this.masterBills.push(<BillData>{type:"OB", billNumber:""});}
		
		this.isf.bills = [...this.houseBills,...this.masterBills];
	}
}
